import React, { FC } from 'react';
import { ResourceData } from '../../../types';
import styles from '../GovernanceTagsModal.module.scss';

interface ModalHeaderProps {
  resource: ResourceData | null;
}

const ModalHeader: FC<ModalHeaderProps> = ({ resource }) => {
  if (!resource) return null;

  const hasGovernanceTags = resource?.governanceTags && resource.governanceTags.length > 0;

  return (
    <div>
      <div>{hasGovernanceTags ? 'Edit' : 'Add'} Resource Virtual Tags</div>
      <div className={styles.resourceInfoLine}>
        <span className={styles.resourceNameHeader}>{resource.resourceName}</span>
        {resource.resourceId && <span className={styles.resourceIdHeader}>({resource.resourceId})</span>}
      </div>
    </div>
  );
};

export default ModalHeader;
